import { FormattedMessage, useIntl } from 'react-intl';
import advancedMapLayers from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/advancedMapLayers';
import allPlusBenefits from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/allPlusBenefits';
import customRoutes from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/customRoutes';
import memberDeals from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/memberDeals';
import offlineMaps from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/offlineMaps';
import routeAssistant from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/routeAssistant';
import trailConditions from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/trailConditions';
import UpsellFeatureList from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/UpsellFeatureList';

type Props = {
  isInUs: boolean;
  isRei?: boolean;
};

export default function PeakMembershipIncludes({ isInUs, isRei }: Props) {
  const intl = useIntl();

  if (isRei) {
    return (
      <UpsellFeatureList
        features={[routeAssistant(intl), advancedMapLayers(intl), customRoutes(intl), allPlusBenefits(intl)]}
        label={<FormattedMessage defaultMessage="Advanced tools for backpackers and bigger adventures" />}
      />
    );
  }

  const features = [
    routeAssistant(intl),
    advancedMapLayers(intl),
    {
      ...customRoutes(intl),
      subheadline: intl.formatMessage({ defaultMessage: 'Start from scratch or customize to create your perfect adventure in the app' })
    },
    offlineMaps(intl),
    isInUs ? memberDeals(intl) : trailConditions(intl)
  ];

  return <UpsellFeatureList features={features} label={<FormattedMessage defaultMessage="Peak membership includes" />} variant="compact" />;
}
